import { render, staticRenderFns } from "./DCP.vue?vue&type=template&id=0afe635c&"
import script from "./DCP.vue?vue&type=script&lang=ts&"
export * from "./DCP.vue?vue&type=script&lang=ts&"
import style0 from "./DCP.vue?vue&type=style&index=0&id=0afe635c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports